// extracted by mini-css-extract-plugin
export default {"BottomNav":"BottomNav_BottomNav__n+w1P","active":"BottomNav_active__P5d3J"};